import { useState } from "react";
import { match } from "ts-pattern";

import { ResponseAnswer } from "~/components/database/detail/database-content/types";
import ResponseConfirm from "~/components/database/detail/response-modal-content/ResponseConfirm";
import ResponseSuccess from "~/components/database/detail/response-modal-content/ResponseSuccess";
import {
  ModalContentStep,
  useModalContentStep,
} from "~/components/database/detail/response-modal-content/lib";
import { Props } from "~/components/database/detail/response-modal-content/lib";
import ResponseForm from "~/components/database/detail/response-modal-content/response-form";

const ResponseModalContent = ({
  form,
  setModalClosable,
  closeModal,
}: Props) => {
  const {
    modalContentStep,
    setModalContentStepToEditor: stepToEditor,
    setModalContentStepToConfirm: stepToConfirm,
    setModalContentStepToSuccess: stepToSuccess,
  } = useModalContentStep();

  // 各投稿への入力
  const [responseAnswers, setResponseAnswers] = useState<ResponseAnswer[]>(
    form.questions.map((question) => ({
      questionId: question.id,
      answerTypeEnum: question.answerType,
    }))
  );

  return match(modalContentStep)
    .with(ModalContentStep.EDITOR, () => (
      <ResponseForm
        form={form}
        responseAnswers={responseAnswers}
        setResponseAnswers={setResponseAnswers}
        stepToConfirm={stepToConfirm}
      />
    ))
    .with(ModalContentStep.CONFIRM, () => (
      <ResponseConfirm
        form={form}
        responseAnswers={responseAnswers}
        stepToEditor={stepToEditor}
        stepToSuccess={stepToSuccess}
      />
    ))
    .with(ModalContentStep.SUCCESS, () => (
      <ResponseSuccess
        categories={form.categories}
        closeModal={closeModal}
        setModalClosable={setModalClosable}
      />
    ))
    .exhaustive();
};

export default ResponseModalContent;
